export default {
  'pages.login.success': '登录成功！',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '请输入用户名!',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '请输入密码！',
  'pages.login.rememberMe': '记住我',
  'pages.login.forgotPassword': '忘记密码？',
  'pages.login.forgotPasswordInfo': '请联系管理员重置密码',
  'pages.login.submit': '登录',
  'pages.login.back': '返回',
  'pages.login.emailCheck.title': '邮箱验证',
  'pages.login.emailCheck.description': '6位验证码已发送至 {email}',
  'pages.login.emailCheck.sent': '验证码已发送至您的邮箱',
  'pages.login.tfaCheck.title': '双因素认证',
  'pages.login.tfaCheck.description': '请输入认证器应用中的6位验证码',
  'pages.login.verifyCode.submit': '验证',
  'pages.login.verifyCode.invalid': '验证码无效',
  'pages.login.oidc.divider': '或使用以下方式登录',
  'pages.login.oidc.continueWith': '使用 {provider} 继续',
  'pages.login.oidc.authFailed': 'OIDC登录失败',
  'pages.devices.list': '设备列表',
  'pages.devices.os': '操作系统',
  'pages.devices.status': '状态',
  'pages.devices.user': '用户',
  'pages.devices.deviceGroup': '设备组',
  'pages.devices.note': '备注',
  'pages.devices.online': '在线',
  'pages.devices.offline': '离线',
  'pages.devices.days': '天',
  'pages.devices.hours': '小时',
  'pages.devices.minutes': '分钟',
  'pages.devices.justNow': '刚刚',
  'pages.devices.enable': '启用',
  'pages.devices.disable': '禁用',
  'pages.devices.enableSuccess': '设备已启用',
  'pages.devices.enableFailed': '启用设备失败',
  'pages.devices.disableSuccess': '设备已禁用',
  'pages.devices.disableFailed': '禁用设备失败',
  'pages.devices.deleteSuccess': '设备已删除',
  'pages.devices.deleteFailed': '删除设备失败',
  'pages.devices.deleteConfirm': '确定要删除此设备吗？',
  'pages.devices.deviceInfo': '用户名@设备名',
  'pages.devices.strategyInfo': '策略信息',
  'pages.devices.device': '设备',
  'pages.devices.strategy': '策略',
  'pages.devices.info': '信息',
  'pages.devices.statusNormal': '正常',
  'pages.devices.statusDisabled': '已禁用',
  'pages.devices.onlineStatus': '在线状态',
  'pages.devices.deviceGroupSearchTip': '按设备组名称筛选',
  'pages.devices.remove': '移除',
  'pages.devices.removeFromGroupSuccess': '设备已从组中移除',
  'pages.devices.removeFromGroupFailed': '从组中移除设备失败',
  'pages.devices.removeFromGroupConfirm': '确定要从组中移除此设备吗？',
  'pages.devices.batchRemove': '批量移除',
  'pages.devices.batchRemoveFromGroupSuccess': '成功从组中移除 {count} 个设备',
  'pages.devices.batchRemoveFromGroupFailed': '从组中移除设备失败',
  'pages.devices.batchRemoveFromGroupConfirm': '确定要从组中移除选中的设备吗？',
  'pages.devices.batchEnable': '批量启用',
  'pages.devices.batchDisable': '批量禁用',
  'pages.devices.batchEnableConfirm': '确定要启用选中的设备吗？',
  'pages.devices.batchDisableConfirm': '确定要禁用选中的设备吗？',
  'pages.devices.batchEnableSuccess': '成功启用 {count} 个设备',
  'pages.devices.batchEnableFailed': '启用设备失败',
  'pages.devices.batchEnablePartialFailed':
    '成功启用 {success} 个设备，{failed} 个失败',
  'pages.devices.batchDisableSuccess': '成功禁用 {count} 个设备',
  'pages.devices.batchDisableFailed': '禁用设备失败',
  'pages.devices.batchDisablePartialFailed':
    '成功禁用 {success} 个设备，{failed} 个失败',
  'pages.devices.edit': '编辑设备',
  'pages.devices.updateSuccess': '设备已更新',
  'pages.devices.updateFailed': '更新设备失败',
  'pages.devices.selectUser': '选择用户',
  'pages.devices.selectDeviceGroup': '选择设备组',
  'pages.devices.selectStrategy': '选择策略',
  'pages.addressBook.name': '名称',
  'pages.addressBook.note': '备注',
  'pages.addressBook.shared': '共享地址簿',
  'pages.addressBook.create': '创建地址簿',
  'pages.addressBook.edit': '编辑地址簿',
  'pages.addressBook.personal': '个人地址簿',
  'pages.addressBook.addPeer': '添加',
  'pages.addressBook.addTag': '添加标签',
  'pages.addressBook.tagName': '标签名称',
  'pages.addressBook.tagAdded': '标签已添加',
  'pages.addressBook.tagAddFailed': '添加标签失败',
  'pages.addressBook.tagDeleted': '标签已删除',
  'pages.addressBook.tagDeleteFailed': '删除标签失败',
  'pages.addressBook.deleteTagConfirm': '确定要删除此标签吗？',
  'pages.addressBook.tagModeUnion': '任一',
  'pages.addressBook.tagModeIntersection': '全部',
  'pages.addressBook.importDevices': '导入设备',
  'pages.addressBook.importSuccess': '成功导入 {count} 个设备',
  'pages.addressBook.importPartialFailed': '{count} 个设备导入失败',
  'pages.addressBook.createSuccess': '地址簿已创建',
  'pages.addressBook.createFailed': '创建地址簿失败',
  'pages.addressBook.updateSuccess': '地址簿已更新',
  'pages.addressBook.updateFailed': '更新地址簿失败',
  'pages.addressBook.deleteSuccess': '地址簿已删除',
  'pages.addressBook.deleteFailed': '删除地址簿失败',
  'pages.addressBook.deleteConfirm': '确定要删除此地址簿吗？',
  'pages.addressBook.batchDeleteConfirm': '确定要删除选中的地址簿吗？',
  'pages.addressBook.device': '设备',
  'pages.addressBook.alias': '别名',
  'pages.addressBook.tags': '标签',
  'pages.addressBook.peerAdded': '设备已添加',
  'pages.addressBook.peerAddFailed': '添加设备失败',
  'pages.addressBook.peerDeleted': '设备已删除',
  'pages.addressBook.peerDeleteFailed': '删除设备失败',
  'pages.addressBook.deletePeerConfirm': '确定要删除此设备吗？',
  'pages.addressBook.import': '导入',
  'pages.addressBook.recycleBin': '回收站',
  'pages.deviceGroups.list': '设备组列表',
  'pages.deviceGroups.name': '名称',
  'pages.deviceGroups.note': '备注',
  'pages.deviceGroups.create': '创建设备组',
  'pages.deviceGroups.edit': '编辑设备组',
  'pages.deviceGroups.createSuccess': '设备组已创建',
  'pages.deviceGroups.createFailed': '创建设备组失败',
  'pages.deviceGroups.updateSuccess': '设备组已更新',
  'pages.deviceGroups.updateFailed': '更新设备组失败',
  'pages.deviceGroups.deleteSuccess': '设备组已删除',
  'pages.deviceGroups.deleteFailed': '删除设备组失败',
  'pages.deviceGroups.deleteConfirm': '确定要删除此设备组吗？',
  'pages.deviceGroups.import': '导入',
  'pages.deviceGroups.importDevices': '导入设备',
  'pages.deviceGroups.importSuccess': '成功导入 {count} 个设备',
  'pages.deviceGroups.importFailed': '导入设备失败',
  'pages.users.list': '用户列表',
  'pages.users.name': '用户名',
  'pages.users.email': '邮箱',
  'pages.users.note': '备注',
  'pages.users.status': '状态',
  'pages.users.create': '创建用户',
  'pages.users.enable': '启用',
  'pages.users.disable': '禁用',
  'pages.users.enableSuccess': '用户已启用',
  'pages.users.enableFailed': '启用用户失败',
  'pages.users.disableSuccess': '用户已禁用',
  'pages.users.disableFailed': '禁用用户失败',
  'pages.users.createSuccess': '用户已创建',
  'pages.users.createFailed': '创建用户失败',
  'pages.users.deleteSuccess': '用户已删除',
  'pages.users.deleteFailed': '删除用户失败',
  'pages.users.deleteConfirm': '确定要删除此用户吗？',
  'pages.audits.conn': '连接审计',
  'pages.audits.file': '文件传输日志',
  'pages.audits.alarm': '告警审计',
  'pages.audits.console': '控制台审计',
  'pages.audits.requestedAt': '请求时间',
  'pages.audits.establishedAt': '建立时间',
  'pages.audits.closedAt': '关闭时间',
  'pages.audits.from': '来源',
  'pages.audits.fromName': '来源名称',
  'pages.audits.to': '目标',
  'pages.audits.toName': '目标名称',
  'pages.audits.action': '操作',
  'pages.audits.time': '时间',
  'pages.audits.alarmType': '告警类型',
  'pages.audits.user': '用户',
  'pages.audits.detail': '详情',
  'pages.audits.type': '类型',
  'pages.audits.connType.remoteDesktop': '远程桌面',
  'pages.audits.connType.fileTransfer': '文件传输',
  'pages.audits.connType.portTransfer': '端口转发',
  'pages.audits.connType.viewCamera': '查看摄像头',
  'pages.audits.connType.terminal': '终端',
  'pages.audits.connType.notLoggedIn': '未登录',
  'pages.audits.duration': '持续时间',
  'pages.audits.note': '备注',
  'pages.audits.disconnect': '断开连接',
  'pages.audits.disconnectSuccess': '已成功断开连接！',
  'pages.audits.disconnectFailed': '断开连接失败！',
  'pages.audits.disconnectConfirmTitle': '确认操作',
  'pages.audits.disconnectConfirmTip': '确定要断开此设备的连接吗？',
  'pages.audits.updateSuccess': '更新成功',
  'pages.audits.updateFailed': '更新失败，请重试！',
  'pages.audits.exportCSV': '导出CSV',
  'pages.audits.noDataToExport': '没有数据可导出',
  'pages.audits.exportSuccess': '导出成功',
  'pages.audits.exportFailed': '导出失败',
  'pages.audits.exportConfirmTitle': '导出CSV',
  'pages.audits.exportConfirmContent': '一次最多导出1000条记录，是否继续？',
  'pages.audits.remote': '远程',
  'pages.audits.local': '本地',
  'pages.audits.direction': '方向',
  'pages.audits.files': '个文件',
  'pages.audits.remoteTip': '远程控制的计算机或终端',
  'pages.audits.remoteSearchTip': '按远程设备ID搜索（模糊匹配）',
  'pages.audits.remotePlaceholder': '请输入远程设备ID',
  'pages.audits.pathTip': '远程设备路径',
  'pages.audits.exportCsvTip': '一次最多导出1000条记录',
  'pages.audits.limitedTip': '按大小显示前10个文件',
  'pages.audits.startTime': '开始时间',
  'pages.audits.endTime': '结束时间',
  'pages.common.action': '操作',
  'pages.common.delete': '删除',
  'pages.common.edit': '编辑',
  'pages.common.batchDelete': '批量删除',
  'pages.common.download': '下载',
  'pages.common.more': '更多',
  'pages.404.subTitle': '抱歉，您访问的页面不存在',
  'pages.404.buttonText': '返回首页',
  'pages.customClients.list': '自定义客户端列表',
  'pages.customClients.name': '客户端名称',
  'pages.customClients.createdAt': '创建时间',
  'pages.customClients.create': '创建自定义客户端',
  'pages.customClients.edit': '编辑自定义客户端',
  'pages.customClients.deleteConfirm': '确定要删除此自定义客户端吗？',
  'pages.customClients.createSuccess': '自定义客户端已创建',
  'pages.customClients.createFailed': '创建自定义客户端失败',
  'pages.customClients.updateSuccess': '自定义客户端已更新',
  'pages.customClients.updateFailed': '更新自定义客户端失败',
  'pages.customClients.deleteSuccess': '自定义客户端已删除',
  'pages.customClients.deleteFailed': '删除自定义客户端失败',
  'pages.customClients.downloadFailed': '下载客户端失败',
  'pages.userGroups.list': '用户组列表',
  'pages.userGroups.name': '组名称',
  'pages.userGroups.note': '备注',
  'pages.userGroups.userCount': '用户数',
  'pages.userGroups.create': '创建用户组',
  'pages.userGroups.edit': '编辑用户组',
  'pages.userGroups.deleteConfirm': '确定要删除此用户组吗？',
  'pages.userGroups.createSuccess': '用户组已创建',
  'pages.userGroups.createFailed': '创建用户组失败',
  'pages.userGroups.updateSuccess': '用户组已更新',
  'pages.userGroups.updateFailed': '更新用户组失败',
  'pages.userGroups.deleteSuccess': '用户组已删除',
  'pages.userGroups.deleteFailed': '删除用户组失败',
  'pages.roles.list': '角色列表',
  'pages.roles.name': '角色名称',
  'pages.roles.note': '备注',
  'pages.roles.permissions': '权限',
  'pages.roles.permissionsInfo': '已分配权限数量',
  'pages.roles.create': '创建角色',
  'pages.roles.edit': '编辑角色',
  'pages.roles.deleteConfirm': '确定要删除此角色吗？',
  'pages.roles.selectPermissions': '选择权限',
  'pages.roles.createSuccess': '角色已创建',
  'pages.roles.createFailed': '创建角色失败',
  'pages.roles.updateSuccess': '角色已更新',
  'pages.roles.updateFailed': '更新角色失败',
  'pages.roles.deleteSuccess': '角色已删除',
  'pages.roles.deleteFailed': '删除角色失败',
  'pages.settings.title': '系统设置',
  'pages.settings.save': '保存设置',
  'pages.settings.general': '常规设置',
  'pages.settings.siteName': '站点名称',
  'pages.settings.adminEmail': '管理员邮箱',
  'pages.settings.language': '默认语言',
  'pages.settings.security': '安全设置',
  'pages.settings.enable2FA': '启用双因素认证',
  'pages.settings.sessionTimeout': '会话超时（分钟）',
  'pages.settings.maxLoginAttempts': '最大登录尝试次数',
  'pages.settings.advanced': '高级设置',
  'pages.settings.logLevel': '日志级别',
  'pages.settings.enableDebugMode': '启用调试模式',
  'pages.settings.fetchFailed': '加载设置失败',
  'pages.settings.saveSuccess': '设置保存成功',
  'pages.settings.saveFailed': '保存设置失败',
  'pages.strategies.list': '策略列表',
  'pages.strategies.name': '策略名称',
  'pages.strategies.note': '备注',
  'pages.strategies.status': '状态',
  'pages.strategies.create': '创建策略',
  'pages.strategies.edit': '编辑策略',
  'pages.strategies.deleteConfirm': '确定要删除此策略吗？',
  'pages.strategies.createSuccess': '策略已创建',
  'pages.strategies.createFailed': '创建策略失败',
  'pages.strategies.updateSuccess': '策略已更新',
  'pages.strategies.updateFailed': '更新策略失败',
  'pages.strategies.deleteSuccess': '策略已删除',
  'pages.strategies.deleteFailed': '删除策略失败',
  'pages.strategies.enterName': '请输入策略名称',
  'pages.strategies.configSummary': '配置摘要',
  'pages.strategies.configCount': '已修改 {modified}/{total} 项',
  'pages.strategies.modifiedAt': '修改时间',
  'pages.strategies.createdAt': '创建时间',
  'pages.strategies.configOptions': '配置选项',
  'pages.strategies.defaultLabel': '默认',
  'pages.strategies.defaultValue': '默认值：{value}',
  'pages.strategies.resetToDefault': '重置为默认值',
  'pages.strategies.modifiedSummary': '已修改 {count} 项配置',
  'pages.strategies.resetAll': '全部重置',
  'pages.strategies.assign': '分配',
  'pages.strategies.assignManagement': '分配管理',
  'pages.strategies.assignDevice': '设备',
  'pages.strategies.assignUser': '用户',
  'pages.strategies.assignDeviceGroup': '设备组',
  'pages.strategies.assignedTargets': '已分配目标',
  'pages.strategies.noAssigned': '暂无已分配目标',
  'pages.strategies.addAssignment': '新增分配',
  'pages.strategies.selectTarget': '请选择目标',
  'pages.strategies.assignSuccess': '策略分配成功',
  'pages.strategies.assignFailed': '策略分配失败',
  'pages.strategies.assignPartialFailed':
    '成功分配 {success} 个目标，{failed} 个失败：{errors}',
  'pages.strategies.unassignSuccess': '策略取消分配成功',
  'pages.strategies.unassignFailed': '策略取消分配失败',
  'pages.strategies.unassignConfirm': '确定要取消分配此目标吗？',
  'pages.strategies.fetchDetailFailed': '获取策略详情失败',
  'pages.strategies.updatedAt': '更新时间',
  'pages.strategies.category.connection': '连接与访问控制',
  'pages.strategies.category.security': '安全与认证',
  'pages.strategies.category.display': '显示与界面',
  'pages.strategies.category.av': '音视频与编解码',
  'pages.strategies.category.file': '文件与剪贴板',
  'pages.strategies.category.advanced': '高级设置',
  'pages.strategies.category.floating': '浮动窗口',
  'pages.strategies.category.privacy': '隐私与录制',
  'pages.strategies.category.hide': '界面隐藏',
  'pages.users.inviteSuccess': '邀请已发送',
  'pages.users.inviteFailed': '发送邀请失败',
  'pages.users.active': '活跃',
  'pages.users.disabled': '已禁用',
  'pages.users.unverified': '未验证',
  'pages.users.roles': '角色',
  'pages.users.rolesInfo': '用户角色和权限',
  'pages.users.strategy': '策略',
  'pages.users.strategyInfo': '用户的连接策略',
  'pages.users.group': '组',
  'pages.users.groupInfo': '用户组分配',
  'pages.users.groupName': '设备组',
  'pages.users.invite': '邀请用户',
  'pages.users.password': '密码',
  'pages.users.isAdmin': '管理员',
  'pages.users.normalUser': '普通用户',
  'pages.users.statusInfo': '用户账户状态',
  'pages.users.edit': '编辑用户',
  'pages.users.updateSuccess': '用户已更新',
  'pages.users.updateFailed': '更新用户失败',
  'pages.users.security': '安全',
  'pages.users.securitySettings': '安全设置',
  'pages.users.securityUpdateSuccess': '安全设置已更新',
  'pages.users.securityUpdateFailed': '更新安全设置失败',
  'pages.users.tfaEnforce': '强制双因素认证',
  'pages.users.emailVerification': '要求邮箱验证',
  'pages.users.forceLogout': '登出',
  'pages.users.forceLogoutSuccess': '强制登出成功',
  'pages.users.forceLogoutFailed': '强制登出失败',
  'pages.users.thirdAuthType': '认证类型',
  'pages.users.createdAt': '创建时间',
  'pages.users.batchEnable': '批量启用',
  'pages.users.batchDisable': '批量禁用',
  'pages.users.batchForceLogout': '批量强制登出',
  'pages.users.batchEnableConfirm': '确定要启用选中的用户吗？',
  'pages.users.batchDisableConfirm': '确定要禁用选中的用户吗？',
  'pages.users.batchForceLogoutConfirm': '确定要强制登出选中的用户吗？',
  'pages.users.batchEnableSuccess': '成功启用 {count} 个用户',
  'pages.users.batchEnableFailed': '启用用户失败',
  'pages.users.batchEnablePartialFailed':
    '成功启用 {success} 个用户，{failed} 个失败',
  'pages.users.batchDisableSuccess': '成功禁用 {count} 个用户',
  'pages.users.batchDisableFailed': '禁用用户失败',
  'pages.users.batchDisablePartialFailed':
    '成功禁用 {success} 个用户，{failed} 个失败',
  'pages.users.batchForceLogoutSuccess': '批量强制登出成功',
  'pages.users.batchForceLogoutFailed': '批量强制登出失败',
  'pages.dashboard.totalUsers': '用户总数',
  'pages.dashboard.activeUsers': '活跃用户',
  'pages.dashboard.totalDevices': '设备总数',
  'pages.dashboard.onlineDevices': '在线设备',
  'pages.dashboard.offlineDevices': '离线设备',
  'pages.dashboard.todayConnections': '今日连接',
  'pages.dashboard.activeConnections': '活跃连接',
  'pages.dashboard.avgDuration': '平均时长',
  'pages.dashboard.totalAlarms': '告警总数',
  'pages.dashboard.criticalAlarms': '严重告警',
  'pages.dashboard.userDistribution': '用户分布',
  'pages.dashboard.adminUsers': '管理员',
  'pages.dashboard.normalUsers': '普通用户',
  'pages.dashboard.deviceDistribution': '设备分布',
  'pages.dashboard.connectionAnalysis': '连接分析',
  'pages.dashboard.successRate': '成功率',
  'pages.dashboard.failureCount': '失败次数',
  'pages.dashboard.totalDuration': '总时长',
  'pages.dashboard.fileTransfer': '文件传输',
  'pages.dashboard.transferredToday': '今日传输',
  'pages.dashboard.totalSize': '总大小',
  'pages.dashboard.uploadCount': '上传次数',
  'pages.dashboard.downloadCount': '下载次数',
  'pages.dashboard.systemStatus': '系统状态',
  'pages.dashboard.uptime': '运行时间',
  'pages.dashboard.trendData': '趋势数据',
  'pages.dashboard.connectionTrend': '连接趋势',
  'pages.dashboard.userActiveTrend': '用户活跃趋势',
  'pages.dashboard.alarmTrend': '告警趋势',
  'pages.dashboard.recentEvents': '最近事件',
  'pages.dashboard.user': '用户',
  'pages.dashboard.device': '设备',
  'pages.dashboard.duration': '时长',
  'pages.dashboard.startTime': '开始时间',
  'pages.dashboard.eventType': '类型',
  'pages.dashboard.action': '动作',
  'pages.dashboard.target': '目标',
  'pages.dashboard.status': '状态',
  'pages.dashboard.time': '时间',
  'pages.common.pleaseEnterName': '请输入名称',
  'pages.common.pleaseEnterPeerId': '请输入对端 ID',
  'pages.common.pleaseEnterTagName': '请输入标签名称',
  'pages.common.pleaseEnterUsername': '请输入用户名',
  'pages.common.pleaseEnterEmail': '请输入邮箱',
  'pages.common.pleaseEnterValidEmail': '请输入有效的邮箱地址',
  'pages.common.pleaseEnterPassword': '请输入密码',
  'pages.common.pleaseEnterRoleName': '请输入角色名称',
  'pages.common.id': 'ID',
  'pages.dashboard.min': '分钟',
  'pages.dashboard.cpu': 'CPU',
  'pages.dashboard.memory': '内存',
  'pages.dashboard.disk': '磁盘',
  'pages.dashboard.inactive': '不活跃',
  'pages.dashboard.onlineRate': '在线率',
  'pages.dashboard.connectionCount': '连接数',
  'pages.dashboard.newUsers': '新增用户',
  'pages.dashboard.7days': '7 天',
  'pages.dashboard.30days': '30 天',
  'pages.dashboard.90days': '90 天',
  'pages.dashboard.noData': '暂无数据',
  'pages.dashboard.resourceDistribution': '资源分布',
  'pages.dashboard.operationAnalysis': '运营分析',
  'pages.smtp.title': 'SMTP 配置',
  'pages.smtp.description': '配置 SMTP 邮件服务器用于发送系统通知邮件',
  'pages.smtp.host': '服务器地址',
  'pages.smtp.hostPlaceholder': '请输入 SMTP 服务器地址',
  'pages.smtp.port': '端口',
  'pages.smtp.portPlaceholder': '请输入端口号',
  'pages.smtp.secure': '使用 SSL/TLS',
  'pages.smtp.secureHelp':
    '启用安全连接（通常端口 465 使用 SSL，端口 587 使用 TLS）',
  'pages.smtp.user': '用户名',
  'pages.smtp.userPlaceholder': '请输入 SMTP 认证用户名',
  'pages.smtp.password': '密码',
  'pages.smtp.passwordPlaceholder': '请输入 SMTP 认证密码',
  'pages.smtp.from': '发件人邮箱',
  'pages.smtp.fromPlaceholder': '请输入发件人邮箱地址',
  'pages.smtp.enabled': '启用配置',
  'pages.smtp.enabledHelp': '启用后将使用此配置发送系统邮件',
  'pages.smtp.testConnection': '测试连接',
  'pages.smtp.testSuccess': 'SMTP 连接测试成功',
  'pages.smtp.testFailed': 'SMTP 连接测试失败',
  'pages.smtp.saveSuccess': 'SMTP 配置保存成功',
  'pages.smtp.saveFailed': 'SMTP 配置保存失败',
  'pages.smtp.createdAt': '创建时间',
  'pages.smtp.updatedAt': '更新时间',
  'pages.addressBook.color': '颜色',
  'pages.addressBook.deviceInfo': '用户名@设备名',
  'pages.addressBook.manageTags': '管理标签',
  'pages.addressBook.newTagName': '新标签名称',
  'pages.addressBook.peerUpdateFailed': '更新对等端失败',
  'pages.addressBook.peerUpdated': '对等端已更新',
  'pages.addressBook.renameTag': '重命名标签',
  'pages.addressBook.selectTags': '选择标签',
  'pages.addressBook.tagColorUpdateFailed': '更新标签颜色失败',
  'pages.addressBook.tagRenameFailed': '重命名标签失败',
  'pages.addressBook.tagRenamed': '标签已重命名',
  'pages.addressBook.untagged': '未标记',
  'pages.common.cancel': '否',
  'pages.common.confirm': '是',
  'pages.common.enterDescription': '请输入描述',
  'pages.common.rename': '重命名',
  'pages.common.save': '保存',
  'pages.customClients.enterName': '请输入客户端名称',
  'pages.settings.chinese': '中文',
  'pages.settings.english': '英文',
  'pages.settings.enterAdminEmail': '请输入管理员邮箱',
  'pages.settings.enterSiteName': '请输入站点名称',
  'pages.settings.logError': '错误',
  'pages.settings.logInfo': '信息',
  'pages.settings.logWarning': '警告',
  'pages.userGroups.enterName': '请输入组名称',
  'pages.users.admin': '管理员',
  'pages.users.me': '我',
  'pages.oidcProviders.list': 'OIDC 提供商列表',
  'pages.oidcProviders.name': '提供商名称',
  'pages.oidcProviders.type': '类型',
  'pages.oidcProviders.issuer': '发行者 URL',
  'pages.oidcProviders.clientId': '客户端 ID',
  'pages.oidcProviders.clientSecret': '客户端密钥',
  'pages.oidcProviders.scope': '授权范围',
  'pages.oidcProviders.authorizationEndpoint': '授权端点',
  'pages.oidcProviders.tokenEndpoint': '令牌端点',
  'pages.oidcProviders.userinfoEndpoint': '用户信息端点',
  'pages.oidcProviders.jwksUri': 'JWKS 端点',
  'pages.oidcProviders.enabled': '启用状态',
  'pages.oidcProviders.priority': '优先级',
  'pages.oidcProviders.endpointConfig': '端点配置',
  'pages.oidcProviders.create': '创建提供商',
  'pages.oidcProviders.edit': '编辑提供商',
  'pages.oidcProviders.test': '测试',
  'pages.oidcProviders.testResult': '测试连接结果',
  'pages.oidcProviders.discoveredEndpoints': '自动发现的端点',
  'pages.oidcProviders.enterName': '请输入提供商名称',
  'pages.oidcProviders.enterIssuer': '请输入发行者 URL',
  'pages.oidcProviders.enterClientId': '请输入客户端 ID',
  'pages.oidcProviders.enterClientSecret': '请输入客户端密钥',
  'pages.oidcProviders.enterEndpoint': '留空则自动发现',
  'pages.oidcProviders.createSuccess': 'OIDC 提供商已创建',
  'pages.oidcProviders.createFailed': '创建 OIDC 提供商失败',
  'pages.oidcProviders.updateSuccess': 'OIDC 提供商已更新',
  'pages.oidcProviders.updateFailed': '更新 OIDC 提供商失败',
  'pages.oidcProviders.deleteSuccess': 'OIDC 提供商已删除',
  'pages.oidcProviders.deleteFailed': '删除 OIDC 提供商失败',
  'pages.oidcProviders.deleteConfirm': '确定要删除此提供商吗？',
  'pages.oidcProviders.enableSuccess': 'OIDC 提供商已启用',
  'pages.oidcProviders.enableFailed': '启用 OIDC 提供商失败',
  'pages.oidcProviders.disableSuccess': 'OIDC 提供商已禁用',
  'pages.oidcProviders.disableFailed': '禁用 OIDC 提供商失败',
  'pages.oidcProviders.enableConfirm': '确定要启用此提供商吗？',
  'pages.oidcProviders.disableConfirm': '确定要禁用此提供商吗？',
  'pages.oidcProviders.testFailed': '测试 OIDC 连接失败',
  'pages.oidcProviders.fetchDetailFailed': '获取提供商详情失败',
  'pages.account.tab.basic': '基本信息',
  'pages.account.tab.avatar': '头像设置',
  'pages.account.tab.security': '安全设置',
  'pages.account.basicInfo.title': '基本信息',
  'pages.account.basicInfo.name': '用户名',
  'pages.account.basicInfo.email': '邮箱',
  'pages.account.basicInfo.note': '备注',
  'pages.account.basicInfo.updateSuccess': '用户信息已更新',
  'pages.account.basicInfo.updateFailed': '更新用户信息失败',
  'pages.account.avatar.title': '头像设置',
  'pages.account.avatar.hint':
    '支持 JPG、PNG、WebP 格式，最大 2MB，将自动缩放为 256x256',
  'pages.account.avatar.upload': '上传头像',
  'pages.account.avatar.delete': '删除头像',
  'pages.account.avatar.deleteConfirm': '确定要删除头像吗？',
  'pages.account.avatar.uploadSuccess': '头像上传成功',
  'pages.account.avatar.uploadFailed': '头像上传失败',
  'pages.account.avatar.deleteSuccess': '头像已删除',
  'pages.account.avatar.deleteFailed': '删除头像失败',
  'pages.account.avatar.fileTooLarge': '文件大小不能超过 2MB',
  'pages.account.avatar.invalidFormat': '仅支持 JPG、PNG、WebP 格式',
  'pages.account.security.title': '安全设置',
  'pages.account.security.2faStatus': '双因素认证状态',
  'pages.account.security.2faAction': '操作',
  'pages.account.security.enabled': '已启用',
  'pages.account.security.disabled': '未启用',
  'pages.account.security.enable2FA': '启用 2FA',
  'pages.account.security.disable2FA': '禁用 2FA',
  'pages.account.security.setup2FA': '设置双因素认证',
  'pages.account.security.setupFailed': '设置 2FA 失败',
  'pages.account.security.scanQRCode':
    '请使用认证器应用扫描二维码，然后输入验证码完成绑定。',
  'pages.account.security.secretKey': '密钥',
  'pages.account.security.verificationCode': '验证码',
  'pages.account.security.enterCode': '请输入验证码',
  'pages.account.security.verifyAndEnable': '验证并启用',
  'pages.account.security.enableSuccess': '2FA 已启用',
  'pages.account.security.enableFailed': '启用 2FA 失败',
  'pages.account.security.currentCode': '当前验证码',
  'pages.account.security.confirmDisable': '确认禁用',
  'pages.account.security.disableSuccess': '2FA 已禁用',
  'pages.account.security.disableFailed': '禁用 2FA 失败',
  'pages.account.security.password': '登录密码',
  'pages.account.security.passwordSet': '已设置',
  'pages.account.security.passwordNotSet': '未设置',
  'pages.account.security.changePassword': '修改密码',
  'pages.account.security.currentPassword': '当前密码',
  'pages.account.security.enterCurrentPassword': '请输入当前密码',
  'pages.account.security.newPassword': '新密码',
  'pages.account.security.enterNewPassword': '请输入新密码（至少6位）',
  'pages.account.security.confirmNewPassword': '确认新密码',
  'pages.account.security.confirmNewPasswordPlaceholder': '请再次输入新密码',
  'pages.account.security.passwordMinLength': '密码长度不能少于6位',
  'pages.account.security.passwordMismatch': '两次输入的密码不一致',
  'pages.account.security.changePasswordSuccess': '密码修改成功',
  'pages.account.security.changePasswordFailed': '密码修改失败',
  'pages.account.security.thirdPartyUser': '第三方登录用户不支持修改密码',
  'pages.account.security.noPasswordUser': '当前账户未设置密码，无法修改',
};
